import { authedFetch, type SessionState } from './session.js';

export interface CredencialMeet { token: string; caducaEn: string; servidor: string }
const mensaje = (codigo: string | undefined): string => codigo === 'usuario_no_activo'
  ? 'Tu usuario no tiene acceso activo a Meet.'
  : codigo === 'meet_no_activado' ? 'Meet todavía no está activado en el servidor.'
    : codigo === 'meet_solo_fluxo' ? 'Meet está disponible en la cuenta Fluxo.' : 'No se ha podido actualizar el acceso a Meet. Vuelve a intentarlo.';

export async function emitirAccesoMeet(session: SessionState): Promise<CredencialMeet> {
  const r = await authedFetch(session, '/api/meet/acceso', { method: 'POST' });
  const datos = await r.json().catch(() => null);
  if (r.status !== 201 || typeof datos?.token !== 'string' || typeof datos?.caducaEn !== 'string') throw new Error(mensaje(datos?.error));
  return { token: datos.token, caducaEn: datos.caducaEn, servidor: datos.servidor };
}

export async function revocarAccesoMeet(session: SessionState): Promise<void> {
  const r = await authedFetch(session, '/api/meet/acceso', { method: 'DELETE' });
  if (r.status !== 200) throw new Error(mensaje((await r.json().catch(() => null))?.error));
}
